import { FormGroup } from '@angular/forms';
import { isEqual } from 'lodash-es';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { addRemoveError, getControl, getFormArray } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';

const DESCRIZIONE_PATH = 'my_AltroAllegatoElementDescrizione';

export const altreNotLibriSocialiAllegatiRules: FormGroupRules = {
    /** Descrizione obbligatoria solo se la riga ha un file; riga vuota o solo descrizione: nessun errore. */
    my_AltroAllegatoElementDescrizione: (form: FormGroup) => {
        getFormArray(form, 'my_AltriAllegati.my_AltroAllegato')?.controls?.forEach((row: FormGroup) => {
            const control = getControl(row, DESCRIZIONE_PATH);
            const errors = control.errors ?? {};

            addRemoveError(isNilOrEmpty(control.value) && !isNilOrEmpty(getControl(row, 'my_AltroAllegatoElement').value), errors, DESCRIZIONE_PATH, {
                status: REQUIRED_STATUS,
            });

            control.setErrors(isEqual(errors, {}) ? null : errors);
        });
    },
};
